var map = {
	"./AboutPublishingCarousel": 1697,
	"./AboutPublishingCarousel.js": 1697,
	"./AboutPublishingCarousel/Main": 1698,
	"./AboutPublishingCarousel/Main.jsx": 1698,
	"./AboutPublishingCarousel/Quote": 740,
	"./AboutPublishingCarousel/Quote.jsx": 740,
	"./AddQualificationModal/AddQualificationModal": 224,
	"./AddQualificationModal/AddQualificationModal.jsx": 224,
	"./AddQualificationModal/Main": 1000,
	"./AddQualificationModal/Main.jsx": 1000,
	"./AdminHomepage/HeroTest": 1001,
	"./AdminHomepage/HeroTest.jsx": 1001,
	"./AdminHomepage/Main": 1002,
	"./AdminHomepage/Main.jsx": 1002,
	"./AdminHomepage/MainContent": 226,
	"./AdminHomepage/MainContent.jsx": 226,
	"./AdminHomepage/Sidebar": 233,
	"./AdminHomepage/Sidebar.jsx": 233,
	"./ArticleShow/Sidebar/MostPopularArticles/Articles": 943,
	"./ArticleShow/Sidebar/MostPopularArticles/Articles.jsx": 943,
	"./ArticleShow/Sidebar/MostPopularArticles/Card": 193,
	"./ArticleShow/Sidebar/MostPopularArticles/Card.jsx": 193,
	"./ChannelCarousel/Channel": 757,
	"./ChannelCarousel/Channel.jsx": 757,
	"./ChannelCarousel/Main": 1703,
	"./ChannelCarousel/Main.jsx": 1703,
	"./ChannelDesign/Home": 694,
	"./ChannelDesign/Home.jsx": 694,
	"./ChannelDesign/HomepageSettings": 241,
	"./ChannelDesign/HomepageSettings.jsx": 241,
	"./ChannelDesign/MainWidgets/FeaturedMultimediaWidget": 309,
	"./ChannelDesign/MainWidgets/FeaturedMultimediaWidget.jsx": 309,
	"./ChannelDesign/Modals/FeaturedMultimediaModal": 308,
	"./ChannelDesign/Modals/FeaturedMultimediaModal.jsx": 308,
	"./CureusEditingServices": 1704,
	"./CureusEditingServices.js": 1704,
	"./CureusEditingServices/Button": 1003,
	"./CureusEditingServices/Button.jsx": 1003,
	"./CureusEditingServices/Calculator": 1705,
	"./CureusEditingServices/Calculator.jsx": 1705,
	"./CureusEditingServices/DropDown": 125,
	"./CureusEditingServices/DropDown.jsx": 125,
	"./Discussions/HomepageContainer": 1005,
	"./Discussions/HomepageContainer.jsx": 1005,
	"./EditorialBoard": 1710,
	"./EditorialBoard.js": 1710,
	"./EditorialBoard/Editor": 773,
	"./EditorialBoard/Editor.jsx": 773,
	"./EditorialBoard/Main": 1711,
	"./EditorialBoard/Main.jsx": 1711,
	"./EditorialBoard/Sidebar": 321,
	"./EditorialBoard/Sidebar.jsx": 321,
	"./FeaturedMultimedia/Main": 304,
	"./FeaturedMultimedia/Main.jsx": 304,
	"./FeaturedMultimedia/MultimediaCard": 305,
	"./FeaturedMultimedia/MultimediaCard.jsx": 305,
	"./FeaturedMultimedia/MultimediaCarousel": 1713,
	"./FeaturedMultimedia/MultimediaCarousel.jsx": 1713,
	"./Guides/AcademicChannelGuide": 777,
	"./Guides/AcademicChannelGuide.jsx": 777,
	"./Guides/AcademicChannelsPages/ChannelEditorialResponsibilities": 782,
	"./Guides/AcademicChannelsPages/ChannelEditorialResponsibilities.jsx": 782,
	"./Guides/AcademicChannelsPages/ChannelEditorialRoles": 781,
	"./Guides/AcademicChannelsPages/ChannelEditorialRoles.jsx": 781,
	"./Guides/AcademicChannelsPages/Faq": 780,
	"./Guides/AcademicChannelsPages/Faq.jsx": 780,
	"./Guides/AcademicChannelsPages/Introduction": 779,
	"./Guides/AcademicChannelsPages/Introduction.jsx": 779,
	"./Guides/AuthorGuide": 783,
	"./Guides/AuthorGuide.jsx": 783,
	"./Guides/AuthorPages/AcceptedArticleTypes": 786,
	"./Guides/AuthorPages/AcceptedArticleTypes.jsx": 786,
	"./Guides/AuthorPages/ArtificialIntelligence": 801,
	"./Guides/AuthorPages/ArtificialIntelligence.jsx": 801,
	"./Guides/AuthorPages/AuthorRoles": 789,
	"./Guides/AuthorPages/AuthorRoles.jsx": 789,
	"./Guides/AuthorPages/BusinessModel": 810,
	"./Guides/AuthorPages/BusinessModel.jsx": 810,
	"./Guides/AuthorPages/CommentingPolicies": 807,
	"./Guides/AuthorPages/CommentingPolicies.jsx": 807,
	"./Guides/AuthorPages/Confidentiality": 806,
	"./Guides/AuthorPages/Confidentiality.jsx": 806,
	"./Guides/AuthorPages/ConflictsOfInterest": 798,
	"./Guides/AuthorPages/ConflictsOfInterest.jsx": 798,
	"./Guides/AuthorPages/CopyrightAndLicensing": 808,
	"./Guides/AuthorPages/CopyrightAndLicensing.jsx": 808,
	"./Guides/AuthorPages/DataCitationAndTransparency": 802,
	"./Guides/AuthorPages/DataCitationAndTransparency.jsx": 802,
	"./Guides/AuthorPages/DisciplineSpecificStandards": 805,
	"./Guides/AuthorPages/DisciplineSpecificStandards.jsx": 805,
	"./Guides/AuthorPages/FreePublication": 785,
	"./Guides/AuthorPages/FreePublication.jsx": 785,
	"./Guides/AuthorPages/HumanAndAnimalSubjects": 799,
	"./Guides/AuthorPages/HumanAndAnimalSubjects.jsx": 799,
	"./Guides/AuthorPages/IcmjeRequirements": 796,
	"./Guides/AuthorPages/IcmjeRequirements.jsx": 796,
	"./Guides/AuthorPages/Introduction": 784,
	"./Guides/AuthorPages/Introduction.jsx": 784,
	"./Guides/AuthorPages/ManagingPeerReview": 791,
	"./Guides/AuthorPages/ManagingPeerReview.jsx": 791,
	"./Guides/AuthorPages/PlagiarismMisconductAndEthics": 797,
	"./Guides/AuthorPages/PlagiarismMisconductAndEthics.jsx": 797,
	"./Guides/AuthorPages/Preregistration": 803,
	"./Guides/AuthorPages/Preregistration.jsx": 803,
	"./Guides/AuthorPages/PromotingYourResearch": 794,
	"./Guides/AuthorPages/PromotingYourResearch.jsx": 794,
	"./Guides/AuthorPages/RaceAndEthnicity": 800,
	"./Guides/AuthorPages/RaceAndEthnicity.jsx": 800,
	"./Guides/AuthorPages/References": 792,
	"./Guides/AuthorPages/References.jsx": 792,
	"./Guides/AuthorPages/ReplicationStudies": 804,
	"./Guides/AuthorPages/ReplicationStudies.jsx": 804,
	"./Guides/AuthorPages/RetractionPolicy": 809,
	"./Guides/AuthorPages/RetractionPolicy.jsx": 809,
	"./Guides/AuthorPages/SeoTips": 793,
	"./Guides/AuthorPages/SeoTips.jsx": 793,
	"./Guides/AuthorPages/SingleBlindedPeerReview": 795,
	"./Guides/AuthorPages/SingleBlindedPeerReview.jsx": 795,
	"./Guides/AuthorPages/StepByStepOverview": 788,
	"./Guides/AuthorPages/StepByStepOverview.jsx": 788,
	"./Guides/AuthorPages/SubmittingAnArticle": 790,
	"./Guides/AuthorPages/SubmittingAnArticle.jsx": 790,
	"./Guides/AuthorPages/UnacceptedArticleTypes": 787,
	"./Guides/AuthorPages/UnacceptedArticleTypes.jsx": 787,
	"./Guides/Card": 124,
	"./Guides/Card.jsx": 124,
	"./Guides/Footer": 216,
	"./Guides/Footer.jsx": 216,
	"./Guides/GuestEditorGuide": 811,
	"./Guides/GuestEditorGuide.jsx": 811,
	"./Guides/GuestEditorPages/FrequentlyAskedQuestions": 815,
	"./Guides/GuestEditorPages/FrequentlyAskedQuestions.jsx": 815,
	"./Guides/GuestEditorPages/GettingStarted": 813,
	"./Guides/GuestEditorPages/GettingStarted.jsx": 813,
	"./Guides/GuestEditorPages/Introduction": 812,
	"./Guides/GuestEditorPages/Introduction.jsx": 812,
	"./Guides/GuestEditorPages/StepByStepInstructions": 814,
	"./Guides/GuestEditorPages/StepByStepInstructions.jsx": 814,
	"./Guides/Main": 1714,
	"./Guides/Main.jsx": 1714,
	"./Guides/MediaGuide": 816,
	"./Guides/MediaGuide.jsx": 816,
	"./Guides/MediaPages/AddingFigures": 821,
	"./Guides/MediaPages/AddingFigures.jsx": 821,
	"./Guides/MediaPages/AddingInteractiveModels": 828,
	"./Guides/MediaPages/AddingInteractiveModels.jsx": 828,
	"./Guides/MediaPages/AddingMedia": 817,
	"./Guides/MediaPages/AddingMedia.jsx": 817,
	"./Guides/MediaPages/AddingTables": 825,
	"./Guides/MediaPages/AddingTables.jsx": 825,
	"./Guides/MediaPages/AddingVideos": 827,
	"./Guides/MediaPages/AddingVideos.jsx": 827,
	"./Guides/MediaPages/FigureRequirements": 820,
	"./Guides/MediaPages/FigureRequirements.jsx": 820,
	"./Guides/MediaPages/GenerativeAiImages": 823,
	"./Guides/MediaPages/GenerativeAiImages.jsx": 823,
	"./Guides/MediaPages/MentioningMedia": 819,
	"./Guides/MediaPages/MentioningMedia.jsx": 819,
	"./Guides/MediaPages/PrivacyAndPermissionIssues": 829,
	"./Guides/MediaPages/PrivacyAndPermissionIssues.jsx": 829,
	"./Guides/MediaPages/TableRequirements": 824,
	"./Guides/MediaPages/TableRequirements.jsx": 824,
	"./Guides/MediaPages/TitleLegendsNumbering": 818,
	"./Guides/MediaPages/TitleLegendsNumbering.jsx": 818,
	"./Guides/MediaPages/UnacceptableFigureExamples": 822,
	"./Guides/MediaPages/UnacceptableFigureExamples.jsx": 822,
	"./Guides/MediaPages/UnacceptableTableExamples": 826,
	"./Guides/MediaPages/UnacceptableTableExamples.jsx": 826,
	"./Guides/Page": 1715,
	"./Guides/Page.jsx": 1715,
	"./Guides/ResultCard": 778,
	"./Guides/ResultCard.jsx": 778,
	"./Guides/ReviewerGuide": 830,
	"./Guides/ReviewerGuide.jsx": 830,
	"./Guides/ReviewerPages/Introduction": 835,
	"./Guides/ReviewerPages/Introduction.jsx": 835,
	"./Guides/ReviewerPages/RereviewProcess": 833,
	"./Guides/ReviewerPages/RereviewProcess.jsx": 833,
	"./Guides/ReviewerPages/StepByStepOverview": 832,
	"./Guides/ReviewerPages/StepByStepOverview.jsx": 832,
	"./Guides/ReviewerPages/SuspectPlagiarism": 834,
	"./Guides/ReviewerPages/SuspectPlagiarism.jsx": 834,
	"./Guides/ReviewerPages/WhyReviewWithCureus": 831,
	"./Guides/ReviewerPages/WhyReviewWithCureus.jsx": 831,
	"./Guides/Root": 1716,
	"./Guides/Root.jsx": 1716,
	"./Guides/SearchBar": 122,
	"./Guides/SearchBar.jsx": 122,
	"./Guides/SearchResults": 56,
	"./Guides/SearchResults.jsx": 56,
	"./Guides/SideNavMenu": 218,
	"./Guides/SideNavMenu.jsx": 218,
	"./Guides/TopNavMenu": 217,
	"./Guides/TopNavMenu.jsx": 217,
	"./Home/ArticleCard": 93,
	"./Home/ArticleCard.jsx": 93,
	"./Home/CureusUCard": 95,
	"./Home/CureusUCard.jsx": 95,
	"./Home/CureusUpdates": 234,
	"./Home/CureusUpdates.jsx": 234,
	"./Home/CureusUpdatesHistoryTable": 1006,
	"./Home/CureusUpdatesHistoryTable.jsx": 1006,
	"./Home/FeaturedContent": 230,
	"./Home/FeaturedContent.jsx": 230,
	"./Home/FeaturedContentCard": 231,
	"./Home/FeaturedContentCard.jsx": 231,
	"./Home/FeaturedContentCarousel": 1007,
	"./Home/FeaturedContentCarousel.jsx": 1007,
	"./Home/FeaturedContentModal": 232,
	"./Home/FeaturedContentModal.jsx": 232,
	"./Home/MetricsCard": 92,
	"./Home/MetricsCard.jsx": 92,
	"./Home/NewsCard": 94,
	"./Home/NewsCard.jsx": 94,
	"./Home/Search": 1008,
	"./Home/Search.jsx": 1008,
	"./Home/VideoImage": 1009,
	"./Home/VideoImage.jsx": 1009,
	"./Home/VideoModal": 243,
	"./Home/VideoModal.jsx": 243,
	"./HomepageFeaturedArticles/Card": 360,
	"./HomepageFeaturedArticles/Card.jsx": 360,
	"./HomepageFeaturedArticles/Content": 244,
	"./HomepageFeaturedArticles/Content.jsx": 244,
	"./HomepageFeaturedArticles/Main": 1010,
	"./HomepageFeaturedArticles/Main.jsx": 1010,
	"./HomepageHeros": 1011,
	"./HomepageHeros.js": 1011,
	"./HomepageHeros/DeleteHeroModal": 229,
	"./HomepageHeros/DeleteHeroModal.jsx": 229,
	"./HomepageHeros/Hero": 228,
	"./HomepageHeros/Hero.jsx": 228,
	"./HomepageHeros/Main": 227,
	"./HomepageHeros/Main.jsx": 227,
	"./InstitutionCarousel/Main": 1717,
	"./InstitutionCarousel/Main.jsx": 1717,
	"./InstitutionCarousel/Post": 836,
	"./InstitutionCarousel/Post.jsx": 836,
	"./MostPopularArticles/Card": 160,
	"./MostPopularArticles/Card.jsx": 160,
	"./MostPopularArticles/Index": 1718,
	"./MostPopularArticles/Index.jsx": 1718,
	"./NotificationsCenter/ApprovalEditorOneMatchModal": 100,
	"./NotificationsCenter/ApprovalEditorOneMatchModal.jsx": 100,
	"./NotificationsCenter/ApprovalEditorResubmittedModal": 101,
	"./NotificationsCenter/ApprovalEditorResubmittedModal.jsx": 101,
	"./NotificationsCenter/ChannelAdminReviewArticlesModal": 102,
	"./NotificationsCenter/ChannelAdminReviewArticlesModal.jsx": 102,
	"./NotificationsCenter/CollectionApplicationApprovalModal": 103,
	"./NotificationsCenter/CollectionApplicationApprovalModal.jsx": 103,
	"./NotificationsCenter/GuestEditorModal": 104,
	"./NotificationsCenter/GuestEditorModal.jsx": 104,
	"./NotificationsCenter/Main": 105,
	"./NotificationsCenter/Main.jsx": 105,
	"./NotificationsCenter/ReviewerModal": 106,
	"./NotificationsCenter/ReviewerModal.jsx": 106,
	"./PicturePrognosisHome/AnswerBarRow": 130,
	"./PicturePrognosisHome/AnswerBarRow.jsx": 130,
	"./PicturePrognosisHome/AnswerOption": 171,
	"./PicturePrognosisHome/AnswerOption.jsx": 171,
	"./PicturePrognosisHome/AnswerOutcome": 250,
	"./PicturePrognosisHome/AnswerOutcome.jsx": 250,
	"./PicturePrognosisHome/Clarification": 251,
	"./PicturePrognosisHome/Clarification.jsx": 251,
	"./PicturePrognosisHome/Landing": 1014,
	"./PicturePrognosisHome/Landing.jsx": 1014,
	"./PicturePrognosisHome/Widget": 287,
	"./PicturePrognosisHome/Widget.jsx": 287,
	"./SocialBoostCarousel/Main": 1725,
	"./SocialBoostCarousel/Main.jsx": 1725,
	"./SocialBoostCarousel/SocialBoostQuote": 885,
	"./SocialBoostCarousel/SocialBoostQuote.jsx": 885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2159;